import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import useSnackBarContext from '@contexts/snackBarContext'
import { MapView } from '@contexts/mapDataContext'
import useDrawerContext from '@contexts/drawerContext'
import { useAuthContext } from '@contexts/authContext'
import useModalContext from '@contexts/modalContext'
import useLoading from '@hooks/useLoading'
import snakecaseKeys from 'snakecase-keys'
import axios from '@utils/webRequests'
import styled from '@emotion/styled'
import { size } from '@styles/theme'
import RegisterModalDisplayNameHandle from './register_modal/RegisterModalDisplayNameHandle'
import RegisterModalEmailPass from '@components/auth/register_modal/RegisterModalEmailPass'
import RegisterModalNextSteps from './register_modal/RegisterModalNextSteps'
import BaseModal from '@elements/BaseModal'
import { BackgroundImage } from './landing/LandingElements'

// const backgroundArr = [
//   // 'https://res.cloudinary.com/da6i1bvlb/image/upload/v1699668977/we-vibe-toys-zMgOtCkeBUg-unsplash.jpg',
//   // 'https://res.cloudinary.com/da6i1bvlb/image/upload/v1699668981/alora-griffiths-bW-BZekV2Dk-unsplash.jpg',
//   'https://res.cloudinary.com/da6i1bvlb/image/upload/v1699668988/sasha-lebedeva-W4_2-V666Wo-unsplash.jpg',
//   // 'https://res.cloudinary.com/da6i1bvlb/image/upload/v1699668989/logan-weaver-lgnwvr-s8Y0yMrfhAk-unsplash.jpg',
// ]

const RegisterModalContainer = styled.div`
  position: relative;
  overflow: hidden;

  width: 90dvw;
  height: ${size(52)};

  border: 0.5px solid grey;
  border-radius: 30px;

  // background:
  //   linear-gradient(180deg, #000 20%,
  //   rgba(0, 0, 0, 0.00) 200%),
  //   url(https://mandrake-app.b-cdn.net/dev/application/display_elements/display-background-1-480w.jpeg),
  //   lightgray 50%;
  // background-repeat: no-repeat;
  // background-cover: center;
  // background-size: cover;
  // background-position: center;
`

const InnerContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: ${size(2.5)};
`

const RegisterUserModal = () => {
  const { closeBottomDrawer, isBottomDrawerOpen } = useDrawerContext()
  const [searchParams, setSearchParams] = useSearchParams()
  const { handleInstantUpdate } = useAuthContext()
  const { addSnackBar } = useSnackBarContext()
  const { registerUser } = useModalContext()
  const navigate = useNavigate()
  const navigatePostCloseRef = useRef('')
  const { isLoading: isEmailPassLoading, setIsLoading: setIsEmailPassLoading, isLoadingDelayed: isEmailPassLoadingDelayed } = useLoading(false)
  const { isLoading: isSubmitLoading, setIsLoading: setIsSubmitLoading, isLoadingDelayed: isSubmitLoadingDelayed } = useLoading(false)
  const [displayHandleFormErrors, setDisplayHandleFormErrors] = useState({})
  const [emailPassFormErrors, setEmailPassFormErrors] = useState({})
  const [startedClosing, setStartedClosing] = useState(false)
  const [formState, setFormState] = useState({
    email: '',
    password: '',
    displayName: '',
    handle: '',
  })

  const currentStep = searchParams.get('step') || 0

  // WARNING: We're going through these steps because the multi-back navigations
  // causes all the previous screen to render before closing... so this hides them
  // for the brief moments the user would otherwise see them all
  useEffect(() => {
    if (startedClosing) {
      if (navigatePostCloseRef.current) {
        navigate(navigatePostCloseRef.current)
      } else {
        let backNavigate = 1
        try { backNavigate = parseInt(currentStep) + 1 } catch {}
        backNavigate = 0 - backNavigate
        navigate(backNavigate)
      }
      navigatePostCloseRef.current = ''
      setStartedClosing(false)
    }
  }, [startedClosing])

  useEffect(() => {
    if (isBottomDrawerOpen && registerUser.isOpen) {
      // WARNING: This is pretty hacky and stupid, but if you navigate away from the modal, and then backnavigate back to the modal
      //          while the bottom drawer is open, the drawer won't reopen in the correct position relative to other contents.
      //          By making the bottom drawer disappear, it causes the bottom drawer to reopen correctly after backnavigation.
      //          It's not clear that this will be an issue in other contexts where the bottom drawer doesn't have to compete with other
      //          modals for stacking priority.
      closeBottomDrawer({ useStrictNavigation: true, replace: true })
    }
  }, [isBottomDrawerOpen, registerUser.isOpen])

  const handleChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value })
  }

  const setHandle = (handle) => {
    setFormState({ ...formState, handle })
  }

  const setHandleErrors = (handleErrors) => {
    const newFormErrors = {...displayHandleFormErrors}
    if (handleErrors) {
      newFormErrors.handle = handleErrors
    } else {
      delete newFormErrors.handle
    }
    setDisplayHandleFormErrors(newFormErrors)
  }
  
  const setPasswordErrors = (passwordErrors) => {
    console.log(passwordErrors)
    const newFormErrors = {...emailPassFormErrors}
    if (passwordErrors) {
      newFormErrors.password = passwordErrors
    } else {
      delete newFormErrors.password
    }
    setEmailPassFormErrors(newFormErrors)

  }

  const emailPassActionCallback = (e) => {
    e.preventDefault()
    setEmailPassFormErrors({})
    setIsEmailPassLoading(true)
    // 1) Submit request to validate email and password
    axios.post(`/api/auth/account_validations`, snakecaseKeys(formState))
      .then((res) => {
        setIsEmailPassLoading(false)
        const emailPassErrors = {}
        if (res.data.email) emailPassErrors.email = res.data.email
        if (res.data.password) emailPassErrors.password = res.data.password
        if (Object.keys(emailPassErrors).length === 0) {
          searchParams.set('step', 1)
          setSearchParams(searchParams)
        } else {
          setEmailPassFormErrors(emailPassErrors)
        }
      })
      .catch((err) => {
        console.log(err)
        setIsEmailPassLoading(false)
        addSnackBar({ message: 'Could not validate form', kind: 'error' })
      })
  }

  // TODO: refactor to handleAnonymousRegister in auth context
  const registerAnonymousUser = (e) => {
    e.preventDefault()
    setIsSubmitLoading(true)
    setDisplayHandleFormErrors({})
    axios.put(`/api/auth/register_users`, snakecaseKeys(formState))
      .then((res) => {
        MapView.updateUser(res.data?.nearbyUuid, { ...res.data, isCurrentUser: true })
        handleInstantUpdate(res.data)
        setIsSubmitLoading(false)
        searchParams.set('step', 2)
        setSearchParams(searchParams)
      })
      .catch((err) => {
        setIsSubmitLoading(false)
        setDisplayHandleFormErrors(err?.response?.data?.errors)
      })
  }

  if (startedClosing) return;
  return(
    <BaseModal
      modalSlotProps={{ backdrop: { style: { backgroundColor: 'rgba(255,255,255,0.25)' } } }}
      noAnimation
      open={registerUser.isOpen}
      setClosed={() => setStartedClosing(true)}>
      <RegisterModalContainer>
        <BackgroundImage src='https://mandrake-app.b-cdn.net/dev/application/display_elements/display-background-2-480w.jpeg' />
        <InnerContainer>
          {(!currentStep || currentStep == 0) &&
            <RegisterModalEmailPass
              formState={formState}
              formErrors={emailPassFormErrors}
              handleChange={handleChange}
              isLoading={isEmailPassLoading}
              isLoadingDelayed={isEmailPassLoadingDelayed}
              actionHandler={emailPassActionCallback}
              setPasswordErrors={setPasswordErrors}
            />
          }
          {currentStep == 1 &&
            <RegisterModalDisplayNameHandle
              formState={formState}
              formErrors={displayHandleFormErrors}
              setHandle={setHandle}
              setHandleErrors={setHandleErrors}
              handleChange={handleChange}
              isLoading={isSubmitLoading}
              isLoadingDelayed={isSubmitLoadingDelayed}
              actionHandler={registerAnonymousUser}
            />
          }
          {currentStep == 2 &&
            <RegisterModalNextSteps
              setClosed={() => setStartedClosing(true)}
              setClosedAndNavigateTo={(to) =>  {
                navigatePostCloseRef.current = to
                setStartedClosing(true)
              }}
            />
          }
        </InnerContainer>
      </RegisterModalContainer>
    </BaseModal>
  )
}

export default RegisterUserModal
